import styled, { css } from 'styled-components';
import { otherColors, secondaryColors } from '@tryhackme/thm-ui-components';

import { CommonContentStyles } from 'src/common/legacy-styles';
import { RoomHeaderStyles } from 'src/common/styles/';

export const getCredentialsCardStylesAsString = (isDarkMode: boolean): string => `
  --credentials-card-connection-bg: ${isDarkMode ? '#2D3D5F' : '#EEEFF2'};
  --credentials-card-connection-ssh-bg: ${isDarkMode ? '#151C2B' : '#D4D8DF'};
  --credentials-card-text-colour: ${isDarkMode ? '#F9F9FB' : '#151C2B'};
`;

// Use the string function with styled-components
export const CredentialsCardStyles = css<{ $isDarkMode: boolean }>`
  ${({ $isDarkMode }) => getCredentialsCardStylesAsString($isDarkMode)}
`;

export const StyledAccordionDetailsMain = styled.div<{
  $isBreakdownExperimentEnabled: boolean;
  $isDarkMode: boolean;
  $isAskEchoEnabled: boolean;
}>`
  padding: ${({ $isBreakdownExperimentEnabled }) => ($isBreakdownExperimentEnabled ? 0 : '3rem')};

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: ${({ $isBreakdownExperimentEnabled }) => ($isBreakdownExperimentEnabled ? 0 : '3rem 1.8rem')};
  }
  ${RoomHeaderStyles}
  // legacy compatibility styles
  ${CommonContentStyles}

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ $isBreakdownExperimentEnabled, theme, $isDarkMode }) => {
      if ($isBreakdownExperimentEnabled) {
        return $isDarkMode ? theme.colors.grey[100] : otherColors.textL;
      }
      return theme.colors.text.main;
    }};
    ${({ $isBreakdownExperimentEnabled }) =>
      $isBreakdownExperimentEnabled &&
      `
        font-size: 2.4rem;
        font-weight: 500;
        margin-bottom: 1.6rem;
        margin-top: 4.6rem;
    `};
  }
  ${({ $isBreakdownExperimentEnabled, $isDarkMode }) =>
    $isBreakdownExperimentEnabled &&
    `
      p {
        color: ${$isDarkMode ? secondaryColors.grey[200] : secondaryColors.grey[900]};
      }
      h2 {
        margin-top: 0;
      }
  `}

  ${({ $isAskEchoEnabled, $isDarkMode }) =>
    $isAskEchoEnabled &&
    css`
      *::selection {
        background: ${$isDarkMode ? 'rgba(65, 46, 96, 1)' : 'rgb(234, 203, 255)'};
        color: ${$isDarkMode ? 'rgba(215, 82, 255, 1)' : 'rgba(102, 0, 202, 1)'};
      }
    `}

  ${CredentialsCardStyles}
`;
